function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0H24V24H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#9e9e9e",
  d: "M13.388 18.25a5.362 5.362 0 0 0 2.868-.831l2.928 2.9 1.7-1.686-2.924-2.889a5.256 5.256 0 0 0 .84-2.838 5.4 5.4 0 1 0-5.412 5.344zm.012-8.312a2.969 2.969 0 1 1-3 2.969 2.986 2.986 0 0 1 3-2.969zM23.6 4H4.4A2.4 2.4 0 0 0 2 6.375v14.25A2.4 2.4 0 0 0 4.4 23h19.2a2.4 2.4 0 0 0 2.4-2.375V6.375A2.4 2.4 0 0 0 23.6 4zm0 16.625H4.4V6.375h19.2z",
  transform: "translate(-2 -2)"
});

function SvgIconPageview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageview);
export default __webpack_public_path__ + "static/media/icon-pageview.73edd0d2.svg";
export { ForwardRef as ReactComponent };